import { greekMessages } from '@/plugins/yup-localization';
import { BaseSchemaBuilder } from '@/views/checkouts/schemas/baseSchema';
import { isValidDate } from '@/views/checkouts/schemas/validators';
import * as yup from 'yup';

export const sharedGroupamaFields = (
  firstDriverAdditionalPremiumAge,
  secondDriverAdditionalPremiumAge,
  firstDriverAdditionalPremiumLicenseYears,
  secondDriverAdditionalPremiumLicenseYears,
  legalEntity,
  secondDriver,
  discountEntity,
  vehicleType
) => {
  let schema = {
    ...BaseSchemaBuilder(true, false, legalEntity, !legalEntity, discountEntity),
    co_owner: yup.boolean().required(),
    tax_office: yup.string().required(),
    nationality: yup.string().required(),
    license_plate: yup.string().required(),
  };

  if (firstDriverAdditionalPremiumLicenseYears) {
    schema = {
      ...schema,
      licenseIssueDate: yup.object({
        day: yup.string().required(),
        month: yup.string().required(),
        year: yup.string().required(),
      }).test('isValidDate', greekMessages.mixed.isValidDate, isValidDate).required(),
    };
  }

  if (secondDriverAdditionalPremiumLicenseYears) {
    schema = {
      ...schema,
      licenseIssueDate2: yup.object().when('only_driver', {
        is: false,
        then: s => s.shape({
          day: yup.string().required(),
          month: yup.string().required(),
          year: yup.string().required(),
        }).test('isValidDate', greekMessages.mixed.isValidDate, isValidDate),
      }),
    };
  }

  schema = {
    ...schema,
    name2: yup.string().when('only_driver', {
      is: false,
      then: s => s.required(),
    }),
    surname2: yup.string().when('only_driver', {
      is: false,
      then: s => s.required(),
    }),
    tax_no2: yup.string().when('only_driver', {
      is: false,
      then: s => s
        .matches(/^\d+$/, {
          message: greekMessages.mixed.isValidAFM,
        })
        .length(9, greekMessages.mixed.isValidAFM)
        .required(),
    }),
    tax_office2: yup.string().when('only_driver', {
      is: false,
      then: s => s.required(),
    }),
    nationality2: yup.string().when('only_driver', {
      is: false,
      then: s => s.required(),
    }),
    license_cat2: yup.string().when('only_driver', {
      is: false,
      then: s => s.required(),
    }),
    address2: yup.string().when('only_driver', {
      is: false,
      then: s => s.required(),
    }),
    address_no2: yup.string().when('only_driver', {
      is: false,
      then: s => s.required(),
    }),
    postal_code2: yup.string().when('only_driver', {
      is: false,
      then: s => s.required(),
    }),
  };

  return schema;
};


export const sharedGroupamaSchemaBuilder = (...args) => yup.object(sharedGroupamaFields(...args));
export default sharedGroupamaSchemaBuilder;
